import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Vote, MousePointerClick, Sparkles, ArrowRight } from "lucide-react";

/**
 * /share/vote-on-poll — Poll click-through reel (iter182).
 *
 * Encourages Facebook / Instagram viewers to tap a link that opens
 * CampCompass, casts their vote on the current weekly poll, AND
 * bounces them into signup. One tap = vote + join.
 */
const PUBLIC_URL = (process.env.REACT_APP_PUBLIC_URL || "https://camp-compass.uk").replace(/\/$/, "");
const LINK = `${PUBLIC_URL}/?vote=1&ref=poll-reel`;

function Scene({ children, bg, label }) {
  return (
    <div className="flex flex-col gap-2 items-center">
      <div className="text-[10px] mono uppercase tracking-[0.25em] text-[#ff4500]">{label}</div>
      <section
        className="relative w-[360px] h-[640px] mx-auto flex flex-col justify-between overflow-hidden text-white"
        style={{ background: bg }}
      >
        {children}
      </section>
    </div>
  );
}

export default function PollVoteReel() {
  return (
    <div className="min-h-screen bg-[#f7f2ec] py-10 px-4">
      <div className="max-w-5xl mx-auto">
        <h1 className="font-display text-4xl mb-2 text-center">Weekly Poll · Vote Reel</h1>
        <p className="text-center text-sm text-[#666] mb-8">One tap on Facebook = vote cast + signed up</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Scene label="Scene 1 · Question" bg="linear-gradient(160deg,#1a237e 0%,#0e0e0e 100%)">
            <div className="p-6 pt-10">
              <div className="inline-block bg-[#ff4500] text-white text-[10px] px-2 py-1 uppercase tracking-widest font-black mb-6">This week's poll</div>
              <h2 className="font-display text-[38px] leading-tight">Where will your<br/>next trip be?</h2>
            </div>
            <div className="p-6 space-y-2">
              {["Lake District", "Cornwall", "Snowdonia", "Peak District"].map((opt) => (
                <div key={opt} className="flex items-center gap-3 bg-white/15 backdrop-blur-sm px-3 py-2.5">
                  <div className="w-4 h-4 rounded-full border-2 border-white" />
                  <span className="text-sm font-bold">{opt}</span>
                </div>
              ))}
              <div className="pt-2 text-[10px] mono uppercase tracking-widest text-white/70">Cast your vote →</div>
            </div>
          </Scene>

          <Scene label="Scene 2 · One tap" bg="#ff4500">
            <div className="p-6 pt-10">
              <div className="inline-block bg-white/25 backdrop-blur-sm text-white text-[10px] px-2 py-1 uppercase tracking-widest font-black mb-6">Facebook · one tap</div>
              <h2 className="font-display text-[40px] leading-none mb-6">Tap once.<br/>Vote cast.<br/>You&rsquo;re in.</h2>
              <div className="bg-white/15 backdrop-blur-sm p-4 space-y-3">
                <div className="flex items-center gap-3 text-sm font-bold"><MousePointerClick className="w-5 h-5 shrink-0" /><span>1 · Tap the link on Facebook</span></div>
                <div className="flex items-center gap-3 text-sm font-bold"><Vote className="w-5 h-5 shrink-0" /><span>2 · Your vote counts instantly</span></div>
                <div className="flex items-center gap-3 text-sm font-bold"><Sparkles className="w-5 h-5 shrink-0" /><span>3 · Free 60s signup</span></div>
              </div>
            </div>
            <div className="p-6 text-[11px] mono uppercase tracking-widest text-white/85">No forms. No spam. Just camp.</div>
          </Scene>

          <Scene label="Scene 3 · CTA + QR" bg="linear-gradient(160deg,#0a7f3f 0%,#0e0e0e 100%)">
            <div className="p-6 pt-10">
              <h2 className="font-display text-[42px] leading-none mb-4">Your vote,<br/>your camp.</h2>
              <p className="text-white/80 text-sm">Join 22,000+ UK campers voting weekly.</p>
            </div>
            <div className="p-6 flex flex-col items-center gap-2 pb-10">
              <div className="bg-white p-2"><QRCodeSVG value={LINK} size={130} /></div>
              <div className="text-[10px] mono uppercase tracking-widest text-white/70">camp-compass.uk</div>
              <div className="inline-flex items-center gap-1.5 text-sm font-bold mt-1"><ArrowRight className="w-4 h-4" /> Vote + join</div>
            </div>
          </Scene>
        </div>

        <div className="mt-10 p-5 bg-white border hairline max-w-3xl mx-auto">
          <div className="eyebrow mb-2">Caption</div>
          <p className="text-sm">🗳️ Where's YOUR next UK camp trip? Tap the link, cast your vote in 1 second, and get a free CampCompass account with 22,000+ sites, weather alerts &amp; camper deals. No card, no catches. Link in bio 🏕️</p>
        </div>
      </div>
    </div>
  );
}
